import { render, staticRenderFns } from "./CajaHolder.vue?vue&type=template&id=a9ec061a&scoped=true"
import script from "./CajaHolder.vue?vue&type=script&lang=js"
export * from "./CajaHolder.vue?vue&type=script&lang=js"
import style0 from "./CajaHolder.vue?vue&type=style&index=0&id=a9ec061a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ec061a",
  null
  
)

export default component.exports